export default "__VITE_ASSET__Cgd5KmJB__"